import UnderlinedText from "./underlined_text";
import { Grid, Typography } from "@mui/material";
import { fieldHeader } from "../../../../components/fields/field_header";

const OwnerInformation = ({ data }: any) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          OWNER INFORMATION:
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Owner Fullname", true)}</Grid>
        <UnderlinedText text={data.primaryOwnerName} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Owner Title", true)}</Grid>
        <UnderlinedText text={data.primaryOwnerTitle} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Owner Email", true)}</Grid>
        <UnderlinedText text={data.primaryOwnerEmail} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Owner Mobile #", false)}</Grid>
        <UnderlinedText text={data.primaryOwnerMobile} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Additional Owner Fullname", false)}</Grid>
        <UnderlinedText text={data.additionalOwnerName} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Additional Owner title", false)}</Grid>
        <UnderlinedText text={data.additionalOwnerTitle} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>
          {fieldHeader("Manager or Main Contact Fullname", false)}
        </Grid>
        <UnderlinedText text={data.managerName} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Manager or Main Contact Phone", false)}</Grid>
        <UnderlinedText text={data.managerPhone} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Manager or Main Contact Email", false)}</Grid>
        <UnderlinedText text={data.managerEmail} />
      </Grid>
    </>
  );
};

export default OwnerInformation;
